import { GHG_INVENTORY_REPORT_ENABLED, GHG_INVENTORY_REPORT_ROUTE } from '../../config/ghgInventoryReportFeature';
import { CITY_ONLY_COPY } from './memberLanguage';
import { municipalReportEligibility } from './geographyEligibility';

export const PREVIEW_LINK_LABEL = 'Preview community inventory report';

export type GhgInventoryReportPreviewState =
  | { kind: 'hidden' }
  | { kind: 'city_only'; message: string }
  | { kind: 'link'; href: string; label: string };

export function ghgInventoryReportPreviewState(
  geofips: number | null | undefined,
  enabled: boolean = GHG_INVENTORY_REPORT_ENABLED
): GhgInventoryReportPreviewState {
  if (!enabled) return { kind: 'hidden' };
  const eligibility = municipalReportEligibility(geofips);
  if (eligibility.reason === 'missing') return { kind: 'hidden' };
  if (!eligibility.eligible) {
    return { kind: 'city_only', message: CITY_ONLY_COPY };
  }
  return {
    kind: 'link',
    href: `${GHG_INVENTORY_REPORT_ROUTE}/${geofips}`,
    label: PREVIEW_LINK_LABEL,
  };
}
